import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export type SupportedLanguages = 'en' | 'zh-HK' | 'zh-CN';
export type SupportedLocales = 'enUS' | 'zhHK' | 'zhCN'; // MUI locales
export const LanguageLoacle: Record<SupportedLanguages, SupportedLocales> = {
    en: 'enUS',
    'zh-HK': 'zhHK',
    'zh-CN': 'zhCN',
};

export function isSupportedLanguage(lang: string): lang is SupportedLanguages {
    return lang in LanguageLoacle;
}

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'zh-HK',
        debug: import.meta.env.MODE === 'production' ? false : true,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
